// Multivariate Dependencies
import React from 'react';
// Components
import { BreathingDot } from '../../BreathingDot';
import { Container } from '../../../common/styles/container/styles/Container';
export var ThreeBreathingDots = function () { return (React.createElement(Container, { display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '24px', height: '4px' },
    React.createElement(BreathingDot, null),
    React.createElement(BreathingDot, { delay: 0.2 }),
    React.createElement(BreathingDot, { delay: 0.4 }))); };
//# sourceMappingURL=ThreeBreathingDots.js.map